import React, {lazy, Suspense} from 'react'
import styled from 'styled-components'
import {StyledLi} from '../styled-components/components'

const NavBarButton = styled.button`
    background:none;
    border:0;
    padding:0;
    margin-top:5px;
    cursor:pointer;
    svg{
        line-height:55px;
        fill: ${props => props.color || "#a4a4a4"};
        path{
            fill: ${props => props.color || "#a4a4a4"};
            transition: .5s all;
        }
        &:hover{
            path{
                fill:white;
            }
        }
    }
`





export default class NavBarItem extends React.Component{


    constructor(props){
        super(props)
        this.state = {svg : null}
        this.SVG = lazy(() => import('../images/navbar/' + this.props.icon));

    }

    render(){
        return (
            <StyledLi><NavBarButton className={this.props.name.toLowerCase().replace(/\s/g, '')} color={this.props.color} icon={this.props.icon} data-tip={this.props.tooltip} onClick = {this.props.onClick}><Suspense fallback=""><this.SVG/></Suspense></NavBarButton></StyledLi>
        )
    }
}

